import { getAxiosClient } from '../http.client';
export function useApiTokensClient() {
    return new ApiTokensClient();
}
export class ApiTokensClient {
    apiClient;
    async client() {
        if (this.apiClient)
            return this.apiClient;
        this.apiClient = getAxiosClient("admin/api-tokens");
        return this.apiClient;
    }
    async listTokens() {
        const client = await this.client();
        const response = await client.get('/');
        return response.data;
    }
    async createToken(data) {
        const client = await this.client();
        const response = await client.post('/', data);
        return response.data;
    }
    async deleteToken(id) {
        const client = await this.client();
        const response = await client.delete(`/${id}`);
        return response.data;
    }
}
